import { APICore } from '../../helpers/api/apiCore';
import * as URL from '../../helpers/api/apiEndPoint';

const api = new APICore();

function getAllCompanies(params: any): any {
    const { search, limit, pages } = params.data
    return api.get(`${URL.GET_ALL_COMPANY}?search=${encodeURIComponent(search)}&limit=${limit}&page=${pages}`);
}
function getCompanyDetails(params: any): any {
    const { search } = params.data

    return api.get(`${URL.GET_COMPANY_DETAILS}?search=${encodeURIComponent(search)}`);
}

function createCompany(params: any): any {
    const { data } = params
    return api.create(URL.CREATE_COMPANY, data);
}

function updateCompany(params: any): any {
    const { data } = params
    return api.update(URL.UPDATE_COMPANY, data);
}

function deleteCompany(params: any): any {
    const { id } = params?.data
    return api.delete(`${URL.DELETE_COMPANY}?id=${id}`);
}

export { getAllCompanies, getCompanyDetails, createCompany, updateCompany, deleteCompany };
